import React from 'react';
import FacebookLinkOption from './options/FacebookLinkOption';
import MemberLinkOption from './options/MemberLinkOption/index';
import { LinkAccountDividerWrapper, LinkAccountRowWrapper } from '../../styledComponents';
import styles from '../../styles';
import ImageBW from '../../../../../components/ImageBoundsWrapper';
import { availableLoginMethodsCount } from 'shared/screens/Start/utils/loginMethodsCounter';
import { ASSET_KEY, assetSource } from 'shared/utils/assetSource';

const DefaultLinkAccount = props => {
  const { rowWrapperStyles = {}, isActionCommand = false, isFriendsInvite = false } = props;
  const { isFacebookAvailable } = availableLoginMethodsCount();

  return (
    <>
      <LinkAccountDividerWrapper disabled={isActionCommand || isFriendsInvite}>
        <ImageBW
          style={styles.divider}
          source={assetSource(ASSET_KEY.SETTINGS_DIVIDER)}
          ibw={require(asset`./images/settings/settings-divider.ibw`)}
          widthScale={0.5}
        />
      </LinkAccountDividerWrapper>
      <LinkAccountRowWrapper styled={rowWrapperStyles}>
        {isFacebookAvailable && <FacebookLinkOption {...props} />}
        <MemberLinkOption {...props} />
      </LinkAccountRowWrapper>
      <LinkAccountDividerWrapper disabled={isActionCommand || isFriendsInvite}>
        <ImageBW
          style={styles.divider}
          source={assetSource(ASSET_KEY.SETTINGS_DIVIDER)}
          ibw={require(asset`./images/settings/settings-divider.ibw`)}
          widthScale={0.5}
        />
      </LinkAccountDividerWrapper>
    </>
  );
};

export default DefaultLinkAccount;

